<template>
	<section ref="container" class="sk-navigation-tab">
		<div class="sk-navigation-tab__items">
			<navigation-tab-item v-for="(tab, index) in tabsMain" :key="index" :route="tab.route" :title="tab.title" />
		</div>
		<div class="sk-navigation-tab__extra">
			<action-group>
				<action-group-item-link v-for="(tab, index) in tabsExtra" :key="index" :route="tab.route" :title="tab.title" />
			</action-group>
		</div>
	</section>
</template>

<script>
import NavigationTabItem from '@/components/navigation/NavigationTabItem'
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemLink from '@/modules/ui/ActionGroupItemLink'
export default {
	name: 'navigation-tab',
	components: {
		NavigationTabItem,
		ActionGroup,
		ActionGroupItemLink,
	},
	props: {
		tabs: {
			type: Array,
			default: []
		}
	},
	computed: {
		tabsMain() {
			return this.tabs.filter(function(tab) { return tab.active === true })
		},
		tabsExtra() {
			return this.tabs.filter(function(tab) { return tab.active === false })
		}
	},
	methods: {
		handleResize() {
			this.updateActives()
		},
		updateActives() {
			const maxWidth = 150
			let size = 0
			this.tabs.forEach(function(tab) { tab.active = false })
			for (const tab of this.tabs) {
				if ((size + maxWidth) > (this.$refs.container.getBoundingClientRect().width - 30)) {
					break
				}
				size += maxWidth
				tab.active = true
			}
		}
	},
	mounted() {
		this.updateActives()
	},
	created() {
		window.addEventListener('resize', this.handleResize)
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>

<style scoped>
.sk-navigation-tab {
	border-bottom: 1px solid #ccc;
	display: flex;
}
.sk-navigation-tab__items {
	display: flex;
	flex: 1;
}
.sk-navigation-tab__extra {
	flex: 0 0 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/navigation/NavigationTab.vue